// Grade 2026/02 transcrita dos PDFs da UNIFENAS-BH.
// O campo sourcePdf preserva as tabelas e o texto extraídos, inclusive escalas de ambulatório.
// As datas dos blocos vêm do calendário já cadastrado em ../data.js; os PDFs de horário não as informam.
// A rotação A/B/C dos blocos 2–4 foi confirmada pela turma.
import sourcePdf from "./sources/period7.json";
const periodDataset = {
  label: "7º período",
  syndromes: {
  "ginecologicas": {
    "name": "Síndromes Ginecológicas",
    "short": "Ginecológicas"
  },
  "neurologicas": {
    "name": "Síndromes Neurológicas",
    "short": "Neurológicas"
  },
  "endocrinas": {
    "name": "Síndromes Endócrinas",
    "short": "Endócrinas"
  },
  "dermato": {
    "name": "Síndromes Dermatológicas",
    "short": "Dermato"
  }
},
  blocks: [
  {
    "number": 1,
    "start": "2026-07-28",
    "end": "2026-08-21",
    "label": "1º bloco"
  },
  {
    "number": 2,
    "start": "2026-08-24",
    "end": "2026-09-25",
    "label": "2º bloco"
  },
  {
    "number": 3,
    "start": "2026-09-28",
    "end": "2026-10-30",
    "label": "3º bloco"
  },
  {
    "number": 4,
    "start": "2026-11-03",
    "end": "2026-12-04",
    "label": "4º bloco"
  }
],
  defaultRotations: {
  "A": {
    "1": "ginecologicas", "2": "neurologicas", "3": "endocrinas", "4": "dermato"
  },
  "B": {
    "1": "ginecologicas", "2": "endocrinas", "3": "dermato", "4": "neurologicas"
  },
  "C": {
    "1": "ginecologicas", "2": "dermato", "3": "neurologicas", "4": "endocrinas"
  }
},
  baseSchedule: {
  "neurologicas": {
    "3": {
      "am1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Fernanda P",
          "location": "201",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Luciana P",
          "location": "203",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Carolina",
          "location": "204",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Rodrigo D",
          "location": "205",
          "kind": "gt"
        }
      },
      "am2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Fernanda P",
          "location": "201",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Luciana P",
          "location": "203",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Carolina",
          "location": "204",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Rodrigo D",
          "location": "205",
          "kind": "gt"
        }
      },
      "pm1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      }
    },
    "5": {
      "am1": {
        "1": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Clarice R",
          "location": "Lab.",
          "kind": "pl"
        },
        "2": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "",
          "location": "patologia",
          "kind": "pl"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "am2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Clarice R",
          "location": "Lab.",
          "kind": "pl"
        },
        "4": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "",
          "location": "patologia",
          "kind": "pl"
        }
      },
      "pm1": {
        "1": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Audrey",
          "location": "Simulação",
          "kind": "th"
        },
        "2": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Daniela B",
          "location": "Simulação",
          "kind": "th"
        },
        "3": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Audrey",
          "location": "Simulação",
          "kind": "th"
        },
        "4": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Daniela B",
          "location": "Simulação",
          "kind": "th"
        }
      },
      "pm2": {
        "1": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Daniela B",
          "location": "Simulação",
          "kind": "th"
        },
        "2": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Audrey",
          "location": "Simulação",
          "kind": "th"
        },
        "3": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Daniela B",
          "location": "Simulação",
          "kind": "th"
        },
        "4": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Audrey",
          "location": "Simulação",
          "kind": "th"
        }
      }
    },
    "2": {
      "am1": {
        "2": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "",
          "kind": "class"
        },
        "3": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "",
          "kind": "class"
        },
        "4": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "",
          "kind": "class"
        },
        "1": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "",
          "kind": "class"
        }
      },
      "am2": {
        "2": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Maria Turci",
          "location": "",
          "kind": "pe"
        },
        "3": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Maria Turci",
          "location": "",
          "kind": "pe"
        },
        "4": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Maria Turci",
          "location": "",
          "kind": "pe"
        },
        "1": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Maria Turci",
          "location": "",
          "kind": "pe"
        }
      },
      "pm1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      }
    },
    "4": {
      "am1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "am2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      }
    },
    "1": {
      "am1": {
        "4": {
          "code": "AF",
          "title": "Ambulatório fixo",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed"
          ]
        }
      },
      "am2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Fernanda P",
          "location": "201",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Luciana P",
          "location": "203",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Carolina",
          "location": "204",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Rodrigo D",
          "location": "205",
          "kind": "gt"
        }
      },
      "pm2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Fernanda P",
          "location": "201",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Luciana P",
          "location": "203",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Carolina",
          "location": "204",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Rodrigo D",
          "location": "205",
          "kind": "gt"
        }
      }
    }
  },
  "endocrinas": {
    "4": {
      "am1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Henrique S",
          "location": "201",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Lívia M",
          "location": "203",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Julia C",
          "location": "204",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Marina N",
          "location": "205",
          "kind": "gt"
        }
      },
      "am2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Henrique S",
          "location": "201",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Lívia M",
          "location": "203",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Julia C",
          "location": "204",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Marina N",
          "location": "205",
          "kind": "gt"
        }
      },
      "pm1": {
        "1": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Marina N",
          "location": "Simulação",
          "kind": "th"
        },
        "2": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Henrique B",
          "location": "Simulação",
          "kind": "th"
        },
        "3": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Denise",
          "location": "Lab.",
          "kind": "pl"
        },
        "4": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Carmona",
          "location": "patologia",
          "kind": "pl"
        }
      },
      "pm2": {
        "1": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Denise",
          "location": "Lab.",
          "kind": "pl"
        },
        "2": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Carmona",
          "location": "patologia",
          "kind": "pl"
        },
        "3": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Marina N",
          "location": "Simulação",
          "kind": "th"
        },
        "4": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Henrique B",
          "location": "Simulação",
          "kind": "th"
        }
      }
    },
    "5": {
      "am1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "am2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm1": {
        "2": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "José Antônio",
          "location": "",
          "kind": "pe"
        },
        "3": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "José Antônio",
          "location": "",
          "kind": "pe"
        },
        "4": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "José Antônio",
          "location": "",
          "kind": "pe"
        },
        "1": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "José Antônio",
          "location": "",
          "kind": "pe"
        }
      },
      "pm2": {
        "2": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "Vários",
          "location": "Poderá ter",
          "kind": "class"
        },
        "3": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "Vários",
          "location": "alterações",
          "kind": "class"
        },
        "4": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "Vários",
          "location": "",
          "kind": "class"
        },
        "1": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "Vários",
          "location": "Poderá ter",
          "kind": "class"
        }
      }
    },
    "2": {
      "am1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "am2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Henrique S",
          "location": "201",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Lívia M",
          "location": "203",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Julia C",
          "location": "204",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Marina N",
          "location": "205",
          "kind": "gt"
        }
      },
      "pm2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Henrique S",
          "location": "201",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Lívia M",
          "location": "203",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Julia C",
          "location": "204",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Marina N",
          "location": "205",
          "kind": "gt"
        }
      }
    },
    "3": {
      "am1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "am2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      }
    },
    "1": {
      "am1": {
        "4": {
          "code": "AF",
          "title": "Ambulatório fixo",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed"
          ]
        }
      },
      "am2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      }
    }
  },
  "dermato": {
    "2": {
      "am1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Luiza R",
          "location": "206",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Nathalia B",
          "location": "208",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Caroline",
          "location": "209",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Ana Luiza M",
          "location": "211",
          "kind": "gt"
        }
      },
      "am2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Luiza R",
          "location": "206",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Nathalia B",
          "location": "208",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Caroline",
          "location": "209",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Ana Luiza M",
          "location": "211",
          "kind": "gt"
        }
      },
      "pm1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Ana Luisa M",
          "location": "Simulação",
          "kind": "th"
        },
        "4": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Nathalia B",
          "location": "Simulação",
          "kind": "th"
        }
      },
      "pm2": {
        "1": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Ana Luisa M",
          "location": "Simulação",
          "kind": "th"
        },
        "2": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Nathalia B",
          "location": "Simulação",
          "kind": "th"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      }
    },
    "3": {
      "am1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Luiz",
          "location": "Lab.",
          "kind": "pl"
        },
        "4": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Alexandre",
          "location": "patologia",
          "kind": "pl"
        }
      },
      "am2": {
        "1": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Luiz",
          "location": "Lab.",
          "kind": "pl"
        },
        "2": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Alexandre",
          "location": "patologia",
          "kind": "pl"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      }
    },
    "4": {
      "am1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Luiza R",
          "location": "206",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Nathalia B",
          "location": "208",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Caroline",
          "location": "209",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Ana Luiza M",
          "location": "211",
          "kind": "gt"
        }
      },
      "am2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Luiza R",
          "location": "206",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Nathalia B",
          "location": "208",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Caroline",
          "location": "209",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Ana Luiza M",
          "location": "211",
          "kind": "gt"
        }
      },
      "pm1": {
        "2": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "",
          "kind": "class"
        },
        "3": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "",
          "kind": "class"
        },
        "4": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "",
          "kind": "class"
        },
        "1": {
          "code": "Seminários",
          "title": "Seminários",
          "professor": "",
          "location": "",
          "kind": "class"
        }
      },
      "pm2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      }
    },
    "5": {
      "am1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "am2": {
        "2": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "",
          "location": "Sala15",
          "kind": "pe"
        },
        "3": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "",
          "location": "CEASC",
          "kind": "pe"
        },
        "4": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "",
          "location": "",
          "kind": "pe"
        },
        "1": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "",
          "location": "Sala15",
          "kind": "pe"
        }
      },
      "pm1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      }
    },
    "1": {
      "am1": {
        "4": {
          "code": "AF",
          "title": "Ambulatório fixo",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed"
          ]
        }
      },
      "am2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm1": {
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      }
    }
  },
  "ginecologicas": {
    "2": {
      "am1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "am2": {
        "2": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Maria Turci",
          "location": "",
          "kind": "pe"
        },
        "3": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Maria Turci",
          "location": "",
          "kind": "pe"
        },
        "4": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Maria Turci",
          "location": "",
          "kind": "pe"
        },
        "1": {
          "code": "PE",
          "title": "Projeto em equipe / metodologias ativas",
          "professor": "Maria Turci",
          "location": "",
          "kind": "pe"
        }
      },
      "pm1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      }
    },
    "3": {
      "am1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Fernanda P",
          "location": "201",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Luciana P",
          "location": "203",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Carolina F",
          "location": "204",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Rodrigo D",
          "location": "205",
          "kind": "gt"
        }
      },
      "am2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Fernanda P",
          "location": "201",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Luciana P",
          "location": "203",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Carolina F",
          "location": "205",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Rodrigo D",
          "location": "205",
          "kind": "gt"
        }
      },
      "pm1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      }
    },
    "5": {
      "am1": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "am2": {
        "1": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "2": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "3": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        },
        "4": {
          "code": "TP",
          "title": "Tempo protegido",
          "professor": "",
          "location": "",
          "kind": "tp"
        }
      },
      "pm1": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        },
        "2": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        },
        "3": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      }
    },
    "4": {
      "am1": {
        "2": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Mariana P",
          "location": "TH04",
          "kind": "th"
        },
        "3": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Denise",
          "location": "Lab.",
          "kind": "pl"
        },
        "4": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Carmona",
          "location": "Patologia",
          "kind": "pl"
        }
      },
      "am2": {
        "1": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Denise",
          "location": "Lab.",
          "kind": "pl"
        },
        "2": {
          "code": "PL",
          "title": "Prática de laboratório",
          "professor": "Carmona",
          "location": "Patologia",
          "kind": "pl"
        },
        "3": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Paulo Boy",
          "location": "TH04",
          "kind": "th"
        },
        "4": {
          "code": "TH",
          "title": "Treinamento de habilidades",
          "professor": "Mariana P",
          "location": "TH04",
          "kind": "th"
        }
      },
      "pm1": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm2": {
        "1": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        },
        "2": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        },
        "3": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        },
        "4": {
          "code": "AE",
          "title": "Ambulatório de especialidades",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "specialty"
          ]
        }
      }
    },
    "1": {
      "am1": {
        "4": {
          "code": "AF",
          "title": "Ambulatório fixo",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed"
          ]
        }
      },
      "am2": {
        "1": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "2": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "3": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        },
        "4": {
          "code": "AMB",
          "title": "Ambulatório ou tempo protegido · consultar escala",
          "professor": "",
          "location": "",
          "kind": "placeholder",
          "accepts": [
            "fixed",
            "specialty"
          ]
        }
      },
      "pm1": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Fernanda P",
          "location": "201",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Luciana P",
          "location": "203",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Carolina F",
          "location": "204",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Rodrigo D",
          "location": "205",
          "kind": "gt"
        }
      },
      "pm2": {
        "1": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Fernanda P",
          "location": "201",
          "kind": "gt"
        },
        "2": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Luciana P",
          "location": "203",
          "kind": "gt"
        },
        "3": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Carolina F",
          "location": "204",
          "kind": "gt"
        },
        "4": {
          "code": "GT",
          "title": "Grupo tutorial",
          "professor": "Rodrigo",
          "location": "205",
          "kind": "gt"
        }
      }
    }
  }
},
  baseScheduleByLetter: {
  "ginecologicas": {
    "A": {
      "2": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "2": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Maria Turci",
            "location": "",
            "kind": "pe"
          },
          "3": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Maria Turci",
            "location": "",
            "kind": "pe"
          },
          "4": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Maria Turci",
            "location": "",
            "kind": "pe"
          },
          "1": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Maria Turci",
            "location": "",
            "kind": "pe"
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      },
      "3": {
        "am1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Fernanda P",
            "location": "201",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Luciana P",
            "location": "203",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Carolina F",
            "location": "204",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rodrigo D",
            "location": "205",
            "kind": "gt"
          }
        },
        "am2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Fernanda P",
            "location": "201",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Luciana P",
            "location": "203",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Carolina F",
            "location": "205",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rodrigo D",
            "location": "205",
            "kind": "gt"
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      },
      "5": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm2": {
          "1": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "2": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "3": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        }
      },
      "4": {
        "am1": {
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Mariana P",
            "location": "TH04",
            "kind": "th"
          },
          "3": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Denise",
            "location": "Lab.",
            "kind": "pl"
          },
          "4": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Carmona",
            "location": "Patologia",
            "kind": "pl"
          }
        },
        "am2": {
          "1": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Denise",
            "location": "Lab.",
            "kind": "pl"
          },
          "2": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Carmona",
            "location": "Patologia",
            "kind": "pl"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Paulo Boy",
            "location": "TH04",
            "kind": "th"
          },
          "4": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Mariana P",
            "location": "TH04",
            "kind": "th"
          }
        },
        "pm1": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm2": {
          "1": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "2": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "3": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        }
      },
      "1": {
        "am1": {
          "4": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          }
        },
        "am2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Fernanda P",
            "location": "201",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Luciana P",
            "location": "203",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Carolina F",
            "location": "204",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rodrigo D",
            "location": "205",
            "kind": "gt"
          }
        },
        "pm2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Fernanda P",
            "location": "201",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Luciana P",
            "location": "203",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Carolina F",
            "location": "204",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Rodrigo",
            "location": "205",
            "kind": "gt"
          }
        }
      }
    },
    "B": {
      "1": {
        "am1": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "",
            "location": "",
            "kind": "th"
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "",
            "location": "",
            "kind": "th"
          },
          "3": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "4": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          }
        },
        "am2": {
          "1": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "2": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          },
          "3": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Paulo Boy",
            "location": "TH04",
            "kind": "th"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Paulo Boy",
            "location": "TH04",
            "kind": "th"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Paulo Boy",
            "location": "TH04",
            "kind": "th"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Paulo Boy",
            "location": "TH04",
            "kind": "th"
          }
        }
      },
      "3": {
        "am1": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "",
            "location": "",
            "kind": "th"
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "",
            "location": "",
            "kind": "th"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "",
            "location": "",
            "kind": "th"
          }
        },
        "am2": {
          "1": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      },
      "5": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "2": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Kevin",
            "location": "",
            "kind": "pe"
          },
          "3": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Kevin",
            "location": "CEASC",
            "kind": "pe"
          },
          "4": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Kevin",
            "location": "",
            "kind": "pe"
          },
          "1": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "Kevin",
            "location": "",
            "kind": "pe"
          }
        },
        "pm1": {
          "1": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Luana",
            "location": "Lab.",
            "kind": "pl"
          },
          "2": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Dourado",
            "location": "Patologia",
            "kind": "pl"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Luana",
            "location": "Lab.",
            "kind": "pl"
          },
          "4": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Dourado",
            "location": "Patologia",
            "kind": "pl"
          }
        }
      },
      "4": {
        "am1": {
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Lívia M",
            "location": "203",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Julia C",
            "location": "204",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Marina N",
            "location": "205",
            "kind": "gt"
          }
        },
        "am2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Henrique S",
            "location": "201",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Lívia M",
            "location": "203",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Julia C",
            "location": "204",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Marina N",
            "location": "205",
            "kind": "gt"
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      },
      "2": {
        "am1": {
          "4": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          }
        },
        "am2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Henrique S",
            "location": "201",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Lívia M",
            "location": "203",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Julia C",
            "location": "204",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Marina N",
            "location": "205",
            "kind": "gt"
          }
        },
        "pm2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Henrique S",
            "location": "201",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Lívia M",
            "location": "203",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Julia C",
            "location": "204",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Marina N",
            "location": "205",
            "kind": "gt"
          }
        }
      }
    },
    "C": {
      "2": {
        "am1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Luiza R",
            "location": "206",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Nathalia B",
            "location": "208",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Caroline",
            "location": "209",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Ana Luiza M",
            "location": "211",
            "kind": "gt"
          }
        },
        "am2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Luiza R",
            "location": "206",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Nathalia B",
            "location": "208",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Caroline",
            "location": "209",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Ana Luiza M",
            "location": "211",
            "kind": "gt"
          }
        },
        "pm1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      },
      "3": {
        "am1": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Rafaela S",
            "location": "TH04",
            "kind": "th"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Rafaela S",
            "location": "TH04",
            "kind": "th"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "am2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Rafaela S",
            "location": "TH04",
            "kind": "th"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "Rafaela S",
            "location": "TH04",
            "kind": "th"
          }
        },
        "pm2": {
          "1": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          },
          "2": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        }
      },
      "4": {
        "am1": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Luiza R",
            "location": "206",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Nathalia B",
            "location": "208",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Caroline",
            "location": "209",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Ana Luiza M",
            "location": "211",
            "kind": "gt"
          }
        },
        "am2": {
          "1": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Luiza R",
            "location": "206",
            "kind": "gt"
          },
          "2": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Nathalia B",
            "location": "208",
            "kind": "gt"
          },
          "3": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Caroline",
            "location": "209",
            "kind": "gt"
          },
          "4": {
            "code": "GT",
            "title": "Grupo tutorial",
            "professor": "Ana Luiza M",
            "location": "211",
            "kind": "gt"
          }
        },
        "pm1": {
          "1": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "",
            "location": "",
            "kind": "th"
          },
          "2": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "",
            "location": "",
            "kind": "th"
          },
          "3": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "",
            "location": "",
            "kind": "th"
          },
          "4": {
            "code": "TH",
            "title": "Treinamento de habilidades",
            "professor": "",
            "location": "",
            "kind": "th"
          }
        },
        "pm2": {
          "1": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "2": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        }
      },
      "5": {
        "am1": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Luana",
            "location": "Lab.",
            "kind": "pl"
          },
          "4": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Dourado",
            "location": "Patologia",
            "kind": "pl"
          }
        },
        "am2": {
          "1": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Luana",
            "location": "Lab.",
            "kind": "pl"
          },
          "2": {
            "code": "PL",
            "title": "Prática de laboratório",
            "professor": "Dourado",
            "location": "Patologia",
            "kind": "pl"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        },
        "pm1": {
          "2": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "José Antônio",
            "location": "",
            "kind": "pe"
          },
          "3": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "José Antônio",
            "location": "",
            "kind": "pe"
          },
          "4": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "José Antônio",
            "location": "",
            "kind": "pe"
          },
          "1": {
            "code": "PE",
            "title": "Projeto em equipe / metodologias ativas",
            "professor": "José Antônio",
            "location": "",
            "kind": "pe"
          }
        },
        "pm2": {
          "1": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "2": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "3": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          },
          "4": {
            "code": "TP",
            "title": "Tempo protegido",
            "professor": "",
            "location": "",
            "kind": "tp"
          }
        }
      },
      "1": {
        "am1": {
          "4": {
            "code": "AF",
            "title": "Ambulatório fixo",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed"
            ]
          }
        },
        "am2": {
          "1": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "2": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        },
        "pm2": {
          "1": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "2": {
            "code": "AE",
            "title": "Ambulatório de especialidades",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "specialty"
            ]
          },
          "3": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          },
          "4": {
            "code": "AMB",
            "title": "Ambulatório ou tempo protegido · consultar escala",
            "professor": "",
            "location": "",
            "kind": "placeholder",
            "accepts": [
              "fixed",
              "specialty"
            ]
          }
        }
      }
    }
  }
},
  fixedClinics: {
  "1": {
    "A": {
      "1": {
        "day": 1,
        "period": "am",
        "code": "AF1",
        "title": "Clínica Médica",
        "professor": "Sidney Vieira",
        "location": "Centro de Saúde Jardim Comerciários/SESC",
        "regional": "Venda Nova",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 1,
        "period": "am",
        "code": "AF2",
        "title": "Clínica Médica",
        "professor": "José Ricardo Oliveira",
        "location": "Centrode Saúde Vila Maria",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 1,
        "period": "am",
        "code": "AF3",
        "title": "Clínica Médica",
        "professor": "Henrique Barros",
        "location": "Centrode Saúde Lagoa",
        "regional": "Venda Nova",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 1,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "",
        "location": "Centrode Saúde Piratininga",
        "regional": "Leste",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 1,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "Maria Fernanda Correa",
        "location": "Centrode Saúde João Vital",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "6": {
        "day": 1,
        "period": "am",
        "code": "AF6",
        "title": "Pediatria",
        "professor": "Fernanda Ribeiro",
        "location": "Centrode Saúde Urucuia",
        "regional": "Barreiro",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "B": {
      "1": {
        "day": 2,
        "period": "am",
        "code": "AF1",
        "title": "Endocrinologia*",
        "professor": "Cláudia M.",
        "location": "CEASC",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 2,
        "period": "am",
        "code": "AF2",
        "title": "Endocrinologia*",
        "professor": "Lívia M",
        "location": "CEASC",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 2,
        "period": "am",
        "code": "AF3",
        "title": "Endocrinologia*",
        "professor": "Nathalia M",
        "location": "CEASC",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 1,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "",
        "location": "Centrode Saúde Nazaré",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 1,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "",
        "location": "",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "C": {
      "1": {
        "day": 3,
        "period": "pm",
        "code": "AF1",
        "title": "Dermatologia*",
        "professor": "",
        "location": "CEASC",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 1,
        "period": "am",
        "code": "AF2",
        "title": "Clínica Médica",
        "professor": "",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 1,
        "period": "am",
        "code": "AF3",
        "title": "Pediatria",
        "professor": "Cristina Borim",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 1,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "Júlia Lima",
        "location": "Centrode Saúde Ouro Preto",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 1,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "Juliana Fernandes B.Coutinho",
        "location": "Centrode Saúde João Vital",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      }
    }
  },
  "2": {
    "A": {
      "1": {
        "day": 1,
        "period": "am",
        "code": "AF1",
        "title": "Clínica Médica",
        "professor": "Sidney Vieira",
        "location": "Centro de Saúde Jardim Comerciários/SESC",
        "regional": "Venda Nova",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 1,
        "period": "am",
        "code": "AF2",
        "title": "Clínica Médica",
        "professor": "José Ricardo Oliveira",
        "location": "Centrode Saúde Vila Maria",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 1,
        "period": "am",
        "code": "AF3",
        "title": "Clínica Médica",
        "professor": "Henrique Barros",
        "location": "Centrode Saúde Lagoa",
        "regional": "Venda Nova",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 1,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "",
        "location": "Centrode Saúde Piratininga",
        "regional": "Leste",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 1,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "Maria Fernanda Correa",
        "location": "Centrode Saúde João Vital",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "6": {
        "day": 1,
        "period": "am",
        "code": "AF6",
        "title": "Pediatria",
        "professor": "Fernanda Ribeiro",
        "location": "Centrode Saúde Urucuia",
        "regional": "Barreiro",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "B": {
      "1": {
        "day": 1,
        "period": "pm",
        "code": "AF1",
        "title": "Cirurgia",
        "professor": "Walter Lozada",
        "location": "CEASC",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 1,
        "period": "am",
        "code": "AF2",
        "title": "Cirurgia",
        "professor": "Mário Carvalho Jr.",
        "location": "CEASC",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 1,
        "period": "am",
        "code": "AF3",
        "title": "Cirurgia",
        "professor": "Leonardo Gasbarro",
        "location": "CEASC",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 1,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "",
        "location": "Centrode Saúde Nazaré",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "C": {
      "1": {
        "day": 1,
        "period": "am",
        "code": "AF1",
        "title": "Cirurgia",
        "professor": "Jefferson Forti",
        "location": "CEASC",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 1,
        "period": "am",
        "code": "AF2",
        "title": "Clínica Médica",
        "professor": "",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 1,
        "period": "am",
        "code": "AF3",
        "title": "Pediatria",
        "professor": "Cristina Borim",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 1,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "Júlia Lima",
        "location": "Centrode Saúde Ouro Preto",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 1,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "Juliana Fernandes B.Coutinho",
        "location": "Centrode Saúde João Vital",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      }
    }
  },
  "3": {
    "A": {
      "1": {
        "day": 1,
        "period": "pm",
        "code": "AF1",
        "title": "Cirurgia",
        "professor": "Walter Lozada",
        "location": "CEASC",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 1,
        "period": "am",
        "code": "AF2",
        "title": "Cirurgia",
        "professor": "Mário Carvalho Jr.",
        "location": "CEASC",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 1,
        "period": "am",
        "code": "AF3",
        "title": "Cirurgia",
        "professor": "Leonardo Gasbarro",
        "location": "CEASC",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 1,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "",
        "location": "Centrode Saúde Piratininga",
        "regional": "Leste",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 1,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "Maria Fernanda Correa",
        "location": "Centrode Saúde Vila Maria",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "6": {
        "day": 1,
        "period": "am",
        "code": "AF6",
        "title": "Pediatria",
        "professor": "Fernanda Ribeiro",
        "location": "Centrode Saúde Urucuia",
        "regional": "Barreiro",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "B": {
      "1": {
        "day": 1,
        "period": "am",
        "code": "AF1",
        "title": "Clínica Médica",
        "professor": "Sidney Vieira",
        "location": "Centro de Saúde Jardim Comerciários/SESC",
        "regional": "Venda Nova",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 1,
        "period": "am",
        "code": "AF2",
        "title": "Clínica Médica",
        "professor": "José Ricardo Oliveira",
        "location": "Centrode Saúde Vila Maria",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 1,
        "period": "am",
        "code": "AF3",
        "title": "Clínica Médica",
        "professor": "Henrique Barros",
        "location": "Centrode Saúde Lagoa",
        "regional": "Venda Nova",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 1,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "",
        "location": "Centrode Saúde Nazaré",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 1,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "",
        "location": "",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "C": {
      "1": {
        "day": 1,
        "period": "am",
        "code": "AF1",
        "title": "Clínica Médica",
        "professor": "",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 1,
        "period": "am",
        "code": "AF2",
        "title": "Cirurgia",
        "professor": "Jefferson Forti",
        "location": "CEASC",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 1,
        "period": "am",
        "code": "AF3",
        "title": "Pediatria",
        "professor": "Cristina Borim",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 1,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "Júlia Lima",
        "location": "Centrode Saúde Ouro Preto",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 1,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "Juliana Fernandes B.Coutinho",
        "location": "Centrode Saúde João Vital",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      }
    }
  },
  "4": {
    "A": {
      "1": {
        "day": 1,
        "period": "pm",
        "code": "AF1",
        "title": "Cirurgia",
        "professor": "Walter Lozada",
        "location": "CEASC",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 1,
        "period": "am",
        "code": "AF2",
        "title": "Cirurgia",
        "professor": "Mário Carvalho Jr.",
        "location": "CEASC",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 1,
        "period": "am",
        "code": "AF3",
        "title": "Cirurgia",
        "professor": "Leonardo Gasbarro",
        "location": "CEASC",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 1,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "",
        "location": "Centrode Saúde Piratininga",
        "regional": "Leste",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 1,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "Maria Fernanda Correa",
        "location": "Centrode Saúde Vila Maria",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "6": {
        "day": 1,
        "period": "am",
        "code": "AF6",
        "title": "Pediatria",
        "professor": "Fernanda Ribeiro",
        "location": "Centrode Saúde Urucuia",
        "regional": "Barreiro",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "B": {
      "1": {
        "day": 1,
        "period": "am",
        "code": "AF1",
        "title": "Clínica Médica",
        "professor": "Sidney Vieira",
        "location": "Centro de Saúde Jardim Comerciários/SESC",
        "regional": "Venda Nova",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 1,
        "period": "am",
        "code": "AF2",
        "title": "Clínica Médica",
        "professor": "José Ricardo Oliveira",
        "location": "Centrode Saúde Vila Maria",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 1,
        "period": "am",
        "code": "AF3",
        "title": "Clínica Médica",
        "professor": "Henrique Barros",
        "location": "Centrode Saúde Lagoa",
        "regional": "Venda Nova",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 1,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "",
        "location": "Centrode Saúde Nazaré",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 1,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "",
        "location": "",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      }
    },
    "C": {
      "1": {
        "day": 1,
        "period": "am",
        "code": "AF1",
        "title": "Clínica Médica",
        "professor": "",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "2": {
        "day": 1,
        "period": "am",
        "code": "AF2",
        "title": "Cirurgia",
        "professor": "Jefferson Forti",
        "location": "CEASC",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "3": {
        "day": 1,
        "period": "am",
        "code": "AF3",
        "title": "Pediatria",
        "professor": "Cristina Borim",
        "location": "Ambulatórioda Igrejado Carmo Sion",
        "regional": "",
        "source": "fixed",
        "kind": "clinic"
      },
      "4": {
        "day": 1,
        "period": "am",
        "code": "AF4",
        "title": "Pediatria",
        "professor": "Júlia Lima",
        "location": "Centrode Saúde Ouro Preto",
        "regional": "Pampulha",
        "source": "fixed",
        "kind": "clinic"
      },
      "5": {
        "day": 1,
        "period": "am",
        "code": "AF5",
        "title": "Pediatria",
        "professor": "Juliana Fernandes B.Coutinho",
        "location": "Centrode Saúde João Vital",
        "regional": "Nordeste",
        "source": "fixed",
        "kind": "clinic"
      }
    }
  }
},
  specialtyClinics: {
  "neurologicas": {
    "1": [
      {
        "day": 2,
        "period": "am",
        "code": "AE1 · END",
        "title": "END",
        "professor": "Cláudia M.",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "pm",
        "code": "AE1 · NEU",
        "title": "NEU",
        "professor": "Audrey A",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "pm",
        "code": "AE1 · PSQ",
        "title": "PSQ",
        "professor": "Thaís",
        "location": "Igreja Carmo",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "2": [
      {
        "day": 2,
        "period": "am",
        "code": "AE2 · END",
        "title": "END",
        "professor": "Lívia M",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 3,
        "period": "am",
        "code": "AE2 · END",
        "title": "END",
        "professor": "Nathalia Alves",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "am",
        "code": "AE2 · PSQ",
        "title": "PSQ",
        "professor": "Larissa Assis",
        "location": "Igreja Carmo",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "pm",
        "code": "AE2 · NEU",
        "title": "NEU",
        "professor": "Andréa P",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "3": [
      {
        "day": 2,
        "period": "am",
        "code": "AE3 · END",
        "title": "END",
        "professor": "Bruna Galvão",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 3,
        "period": "pm",
        "code": "AE3 · PSQ",
        "title": "PSQ",
        "professor": "Larissa Assis",
        "location": "Igreja Carmo",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "pm",
        "code": "AE3 · NEU",
        "title": "NEU",
        "professor": "Renata B",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "4": [
      {
        "day": 3,
        "period": "am",
        "code": "AE4 · END",
        "title": "END",
        "professor": "Talita O",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 2,
        "period": "pm",
        "code": "AE4 · PSQ",
        "title": "PSQ",
        "professor": "Daniela B",
        "location": "C",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 3,
        "period": "pm",
        "code": "AE4 · NEU",
        "title": "NEU",
        "professor": "Renata B",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "5": [
      {
        "day": 2,
        "period": "am",
        "code": "AE5 · END",
        "title": "END",
        "professor": "Henrique S",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "am",
        "code": "AE5 · NEU",
        "title": "NEU",
        "professor": "Andréa P",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 4,
        "period": "pm",
        "code": "AE5 · PSQ",
        "title": "PSQ",
        "professor": "Larissa Assis",
        "location": "Igreja Carmo",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ]
  },
  "endocrinas": {
    "1": [
      {
        "day": 3,
        "period": "pm",
        "code": "AE1 · END",
        "title": "END",
        "professor": "Nathalia Alves",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "3": [
      {
        "day": 3,
        "period": "pm",
        "code": "AE3 · END",
        "title": "END",
        "professor": "Talita O",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "4": [
      {
        "day": 1,
        "period": "pm",
        "code": "AE4 · END",
        "title": "END",
        "professor": "Cláudia M.",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "5": [
      {
        "day": 1,
        "period": "pm",
        "code": "AE5 · END",
        "title": "END",
        "professor": "Nathalia Alves",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ]
  },
  "dermato": {
    "1": [
      {
        "day": 3,
        "period": "pm",
        "code": "AE1 · DER",
        "title": "DER",
        "professor": "Luiza Rennó",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 5,
        "period": "pm",
        "code": "AE1 · CIR",
        "title": "CIR",
        "professor": "Fernanda C P",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "2": [
      {
        "day": 1,
        "period": "pm",
        "code": "AE2 · CIR",
        "title": "CIR",
        "professor": "Jefferson F",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 5,
        "period": "pm",
        "code": "AE2 · DER",
        "title": "DER",
        "professor": "Isadora M",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "3": [
      {
        "day": 1,
        "period": "pm",
        "code": "AE3 · DER",
        "title": "DER",
        "professor": "Isadora M",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 3,
        "period": "pm",
        "code": "AE3 · CIR",
        "title": "CIR",
        "professor": "José Eduardo",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "4": [
      {
        "day": 4,
        "period": "pm",
        "code": "AE4 · CIR",
        "title": "CIR",
        "professor": "Fábio H",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 5,
        "period": "pm",
        "code": "AE4 · DER",
        "title": "DER",
        "professor": "Guilherme S",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ],
    "5": [
      {
        "day": 1,
        "period": "pm",
        "code": "AE5 · CIR",
        "title": "CIR",
        "professor": "José Eduardo",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      },
      {
        "day": 3,
        "period": "pm",
        "code": "AE5 · DER",
        "title": "DER",
        "professor": "Guilherme S",
        "location": "CEASC",
        "regional": "",
        "source": "specialty",
        "kind": "clinic"
      }
    ]
  }
},
  extraCatalog: [],
  sourcePdf
};
export default periodDataset;
